import { DateTime } from "luxon";
import type { QuoteRealization, QuoteRealizationLine } from "cadendar-shared";

const realizationLabels: Record<QuoteRealization["state"], string> = {
  none: "Aucun acte retrouvé",
  partial: "Partiellement réalisé",
  performed: "Réalisé automatiquement",
  ambiguous: "Correspondance ambiguë",
  unverifiable: "Réalisation non vérifiable",
  excluded: "Détection exclue : devis invalide",
};
const lineLabels: Record<QuoteRealizationLine["state"], string> = {
  performed: "Réalisé",
  not_found: "Non retrouvé",
  ambiguous: "Plusieurs devis possibles",
  unverifiable: "Code CCAM ou dent manquant/inexploitable",
};

export default function QuoteRealizationIndicator({
  realization,
}: {
  realization: QuoteRealization;
}) {
  return (
    <div className="space-y-1 text-sm">
      <p
        className={
          realization.state === "performed"
            ? "font-medium text-green-800"
            : realization.ambiguousLines > 0
              ? "text-amber-800"
              : "text-slate-600"
        }
      >
        {realizationLabels[realization.state]}
        {realization.state !== "excluded" && (
          <>
            {" "}
            · {realization.performedLines}/{realization.totalLines} actes
          </>
        )}
      </p>
      {realization.completionDate && (
        <p className="text-xs text-slate-500">
          Dernier acte le{" "}
          {DateTime.fromISO(realization.completionDate).toFormat("dd/MM/yyyy")}
        </p>
      )}
      {realization.withoutRecordedAcceptance && (
        <p className="text-xs text-amber-800">
          Réalisé sans acceptation enregistrée
        </p>
      )}
      {realization.ambiguousLines > 0 && (
        <p className="text-xs text-amber-800">
          {realization.ambiguousLines} acte(s) également proposé(s) dans
          d’autres devis : attribution non confirmée.
        </p>
      )}
      {realization.unverifiableLines > 0 &&
        realization.state !== "excluded" && (
          <p className="text-xs text-slate-500">
            {realization.unverifiableLines} ligne(s) non vérifiable(s)
            automatiquement.
          </p>
        )}
      {realization.totalLines > 0 && realization.state !== "excluded" && (
        <details className="text-xs text-slate-600">
          <summary className="cursor-pointer">
            Détail de la détection automatique
          </summary>
          <ul className="mt-2 space-y-2">
            {realization.lines.map((line) => (
              <li key={line.lineId}>
                <p className="font-medium">{line.description}</p>
                <p>
                  {line.ccamCode ?? "Sans code CCAM"} ·{" "}
                  {line.teeth.length ? line.teeth.join(", ") : "Sans dent"} ·{" "}
                  {lineLabels[line.state]}
                  {line.performedDate && (
                    <>
                      {" "}
                      le{" "}
                      {DateTime.fromISO(line.performedDate).toFormat(
                        "dd/MM/yyyy",
                      )}
                    </>
                  )}
                </p>
              </li>
            ))}
          </ul>
          <p className="mt-2 text-slate-400">
            Correspondances dans les actes Logos synchronisés, depuis la
            création du devis. Les alternatives sont exclues. Cette détection ne
            vaut pas acceptation.
          </p>
        </details>
      )}
    </div>
  );
}
